import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'tea-component';
import { versionOptions } from '../../constants/date';
import type { SingleCommonType, VersionDateType } from '../../types';
import { commonBackInfo } from '../../utils';
import './index.scss';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { addFilterBuriedPoint } from '../../utils/point';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
/**
 * version版本的时间选择 launched_time
 * @param value         值
 * @param setValue      设置值的方法
 * @param disabled      是否为不激活状态
 * @param isCompetitor  是否为对比页
 * @param onFocus       获取焦点操作
 * @returns
 */
export default function VersionTimeSelect({
  onChange,
  defaultKey,
}: SingleCommonType) {
  const [value, setValue] = useState<string>('1-day');
  const { formatMessage, formatOptionsMessage } = useLanguage();

  const dataChange = () => {
    const [period, date_type] = value.split('-');

    let result: VersionDateType = {
      date_type: date_type,
      period: Number(period),
      version_time: period,
    };

    onChange?.(
      'versionTime',
      commonBackInfo(result, { [defaultKey]: buttonText }),
    );
  };

  useEffect(() => {
    dataChange();
  }, [value, formatMessage]);

  const buttonText = useMemo(() => {
    return (
      <div className="filterbox-left-text">
        <span className="select-button-text">
          {formatMessage({ id: 'Period' })}
        </span>
        <span className="select-button-value">
          {versionOptions.map((v) => {
            if (value === v.value) {
              return formatMessage({ id: v.text });
            }
          })}
        </span>
      </div>
    );
  }, [value, formatMessage]);

  return (
    <Select
      value={value}
      appearance="button"
      matchButtonWidth
      className="version-time-picker-wrapper"
      button={buttonText}
      options={formatOptionsMessage(versionOptions)}
      onChange={(value) => {
        setValue(value);

        addFilterBuriedPoint(FilterButtonPoint.versionTime, value);
      }}
    ></Select>
  );
}
